import type { FC } from 'react';
import { Box } from '@mui/material';
import type { BoxProps } from '@mui/system';

import type {
  ModuleOrPlanActionOrgUnit,
  ModulePermissionOrgUnit,
  PlanActionPermissionOrgUnit,
} from 'src/types/orgUnit';
import OrgUnit from 'src/components/common/OrgTree/components/OrgTreeSearch/components/OrgUnitList/components/orgUnit';

export interface OrgUnitListProps extends Omit<BoxProps, 'onSelect'> {
  createLabel: (...params: any[]) => any;
  onSelect: (orgUnit: ModuleOrPlanActionOrgUnit) => void;
  orgUnits: ModulePermissionOrgUnit[] | PlanActionPermissionOrgUnit[];
}

const OrgUnitList: FC<OrgUnitListProps> = ({
  createLabel,
  onSelect,
  orgUnits,
}) => (
  <Box data-test-id="org-tree-list">
    {orgUnits.map((orgUnit) => (
      <OrgUnit
        createLabel={createLabel}
        onSelect={onSelect}
        orgUnit={orgUnit}
        key={orgUnit.id}
      />
    ))}
  </Box>
);

export default OrgUnitList;
